import { jsx, jsxs } from "react/jsx-runtime";
import { resolveUser } from "../../../../Header.helpers.js";
import Container from "../../../../../../layout/Container/Container.js";
import Divider from "../../../../../../layout/Divider/Divider.js";
import Group from "../../../../../../layout/Group/Group.js";
import TextLink from "../../../../../../navigation/TextLink/TextLink.js";
import Paragraph from "../../../../../../typography/Paragraph/Paragraph.js";
import { rem, Menu } from "@mantine/core";
import { Fragment } from "react";
import { L as LocalNavbarStyles } from "../../../../../../../LocalNavbar.module-D_uZkV8K.js";
import NavbarSkeletons from "./NavbarSkeletons.js";
const NavbarMiddle = ({
  isLoading,
  actionLink,
  openDropdowns,
  links,
  openDropdownsHandlers,
  user,
  showUserLogin,
  handleClick
}) => {
  let resolvedActionLink;
  if (!actionLink) {
    if (showUserLogin) {
      resolvedActionLink = resolveUser(user);
    }
  } else {
    resolvedActionLink = {
      header: actionLink.text,
      href: actionLink.href,
      items: []
    };
  }
  const resolvedlinks = [...links || []];
  if (resolvedActionLink) {
    resolvedlinks.push(resolvedActionLink);
  }
  const toggleDropdown = (index, newValue) => {
    openDropdownsHandlers.setItem(index, newValue);
  };
  const shouldRenderDropdown = (group) => {
    if (group.readMore) {
      return true;
    }
    if (group.special) {
      return true;
    }
    if (group.items && group.items.length > 0) {
      return true;
    }
    return false;
  };
  return /* @__PURE__ */ jsx(Group, { align: "center", spacing: rem("20px"), className: LocalNavbarStyles.middle, children: isLoading ? /* @__PURE__ */ jsx(NavbarSkeletons, {}) : resolvedlinks == null ? void 0 : resolvedlinks.map((group, index) => {
    var _a;
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      group.items && group.items.length > 0 && // Accessibility trigger for menu
      /* @__PURE__ */ jsx(
        "div",
        {
          onClick: () => toggleDropdown(index, !openDropdowns[index]),
          onKeyDown: (event) => {
            if (event.key === "Enter") {
              toggleDropdown(index, !openDropdowns[index]);
            }
          },
          "aria-label": `Åben undermenu for ${group.header}`,
          role: "button",
          tabIndex: 0,
          style: { position: "absolute" }
        }
      ),
      /* @__PURE__ */ jsxs(
        Menu,
        {
          trigger: "hover",
          radius: 0,
          position: "bottom",
          width: "100%",
          withinPortal: true,
          portalProps: {
            target: "header"
          },
          onChange: (value) => toggleDropdown(index, value),
          opened: openDropdowns[index],
          children: [
            /* @__PURE__ */ jsx(Menu.Target, { children: /* @__PURE__ */ jsxs(Group, { spacing: "lg", children: [
              index === resolvedlinks.length - 1 && resolvedActionLink && /* @__PURE__ */ jsx(
                Divider,
                {
                  color: "light",
                  orientation: "vertical",
                  className: LocalNavbarStyles.divider
                }
              ),
              /* @__PURE__ */ jsx(
                TextLink,
                {
                  variant: "header",
                  color: "light",
                  className: LocalNavbarStyles.localLink,
                  text: group.header,
                  href: group.href,
                  target: group.target,
                  icon: group.icon,
                  iconBackground: "dark",
                  iconPlacement: "left",
                  selected: openDropdowns[index],
                  onClick: () => handleClick(group.header, group.href)
                }
              )
            ] }) }),
            shouldRenderDropdown(group) && /* @__PURE__ */ jsx(Menu.Dropdown, { p: 0, className: LocalNavbarStyles.dropdown, children: /* @__PURE__ */ jsxs(Container, { size: "global", pb: "md", children: [
              /* @__PURE__ */ jsx(
                Group,
                {
                  className: LocalNavbarStyles.navigationGroup,
                  py: "xl",
                  align: "top",
                  wrap: "nowrap",
                  children: (_a = group.items) == null ? void 0 : _a.map((item, subIndex) => /* @__PURE__ */ jsxs(
                    Group,
                    {
                      direction: "column",
                      className: LocalNavbarStyles.linkGroup,
                      spacing: "md",
                      children: [
                        item.header && /* @__PURE__ */ jsx(Paragraph, { strong: true, scale: 1.3, text: item.header, variant: "light" }),
                        /* @__PURE__ */ jsx(Group, { className: LocalNavbarStyles.linkColumn, children: item.links.map((link, linkIndex) => /* @__PURE__ */ jsx(
                          TextLink,
                          {
                            variant: "header",
                            color: "light",
                            className: LocalNavbarStyles.localLink,
                            text: link.text,
                            href: link.href,
                            target: link.target,
                            onClick: () => handleClick(link.text, link.href)
                          },
                          `${link.text}+${linkIndex}`
                        )) })
                      ]
                    },
                    `${item.header}${subIndex}`
                  ))
                }
              ),
              group.readMore && /* @__PURE__ */ jsx(
                TextLink,
                {
                  variant: "component",
                  color: "light",
                  icon: group.readMore.chevron ? group.readMore.chevron : "ChevronRight",
                  iconPlacement: "right",
                  className: LocalNavbarStyles.readMore,
                  text: group.readMore.text,
                  href: group.readMore.href,
                  target: group.readMore.target,
                  mr: 0,
                  ml: "auto",
                  onClick: () => {
                    var _a2, _b;
                    return handleClick(
                      ((_a2 = group.readMore) == null ? void 0 : _a2.text) || "",
                      ((_b = group.readMore) == null ? void 0 : _b.href) || ""
                    );
                  }
                }
              ),
              group.special && /* @__PURE__ */ jsx(
                TextLink,
                {
                  variant: "component",
                  color: "light",
                  icon: group.special.chevron ? group.special.chevron : "ChevronRight",
                  iconPlacement: "right",
                  className: LocalNavbarStyles.readMore,
                  text: group.special.text,
                  href: group.special.href,
                  target: group.special.target,
                  mr: 0,
                  ml: "auto",
                  onClick: () => {
                    var _a2, _b;
                    return handleClick(
                      ((_a2 = group.special) == null ? void 0 : _a2.text) || "",
                      ((_b = group.special) == null ? void 0 : _b.href) || ""
                    );
                  }
                }
              )
            ] }) })
          ]
        }
      )
    ] }, `${group.header}${index}`);
  }) });
};
export {
  NavbarMiddle as default
};
